import React, {useState, useEffect} from 'react';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { BuscadorLocalidad } from './BuscadorLocalidad';


export const Buscador = (props) =>{
    const {
		Empresas,
		setEmpresas,
		mapa,
		setMapa,
		setModalUbiacion,
		setEmpresasCargadas,
		getEmpresas_preRegistradas,
		limite,
		setBuscarNombre,
		setBuscarCategoria,
		setBuscarLocalidad,
		setBuscarProvincia,
		distance,
		listaRating,
		sortBy,
		setLoading,
		setLoadingCargadas,
	} = props;

	const navigate = useNavigate()

    const [ListaProvincias, setListaProvincias] = useState([]);

	const [showLocalidades, setShowLocalidades] = useState(false);
    const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [Provincia, setProvincia] = useState({
		nombre: 'Todas',
		id: 0,
	});

    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [NombreBuscar, setNombreBuscar] = useState(''.toString());
	const [busqueda, setBusqueda] = useState('')

    const [localidadSeleccionada, setLocalidadSeleccionada] = useState([])
    const [Localidad, setLocalidad] = useState({
		nombre: '',
		id: 0,
	});

	const [Ubicacion, setUbicacion] = useState({
		lat: '38.57065590139325',
		lng: ' -6.196927275067296'
	})

    const [Categorias, setCategorias] = useState([]);
	const [CategoriaSeleccionada, setCategoriaSeleccionada] = useState({
		nombre: '',
		id: 0,
	});

	const categoriasPrincipales = [
		'Todas',
		'Valoración geriátrica integral',
		'Tablet estimulación cognitiva, telemedicina, etc',
		'Fisioterapia', 
		'Podología',
		'Peluquería',
		'Ayuda a domicilio',
		'Peluquería canina',
		'Paseo y cuidado de mascotas',
		'Acompañamiento geriátrico integral'
	]

	const [empresasCercanas, setEmpresasCercanas] = useState([])

	const [busquedaURL, setBusquedaURL] = useState(false)

	const {search} = useLocation();
	const query = new URLSearchParams(search)

	useEffect(()=>{
		const q = query.get('q');
		const lugar = query.get('lugar')
		const categoria = query.get('categoria')

		const fetchEmpresas = async () => {
			setLoading(true)
			setLoadingCargadas(true)
			await Promise.allSettled([
				searchEmpresas(q,lugar, distance, categoria),
				searchEmpresas_Cargadas(q,lugar, distance, categoria),
			])
		}

		fetchEmpresas()
		// getDistance(lugar)
	},[search, distance, listaRating])

	const getDistance = async (localidad_id) =>{
		try{
			const response = await axios.get(window.ipdirection + 'localidadAll/'+ localidad_id)
			let key = 'a16e7e3fda0f7cb5b44a1045f02b6923'
			const response_coord = await axios.get('https://api.openweathermap.org/geo/1.0/direct?q='+response.data.nombre+',ES&appid='+key)

			let localidad_lat = response_coord.data[0].lat
			let localidad_lng = response_coord.data[0].lon

			return {lat:localidad_lat, lng:localidad_lng}
			
			// const empresasActualizadas = await Promise.all(
			// Empresas.map(async (empresa)=>{
			// 	const response = await axios.get(window.ipdirection + 'sedePrestador/?idempresa='+ empresa.id)
			// 	const empresa_sede =response.data
			// 	console.log('empresa_sede', empresa_sede);
			// 	const distances = empresa_sede.map((sede)=> calcular_distancia(sede.lat, sede.lng, localidad_lat, localidad_lng, 'K'))
			// 	const distanciaMin = Math.min(...distances)
			// 	console.log('distanciaMin', distanciaMin);

			// 	return {...empresa, distancia: distanciaMin}
			// }))

			// setEmpresas(empresasActualizadas)
		}catch(error){
			console.log('Error', error)
		}
	}

	function calcular_distancia(lat1, lon1, lat2, lon2, unit) {
		if (lat1 == lat2 && lon1 == lon2) {
			return 0;
		} else {
			var radlat1 = (Math.PI * lat1) / 180;
			var radlat2 = (Math.PI * lat2) / 180;
			var theta = lon1 - lon2;
			var radtheta = (Math.PI * theta) / 180;
			var dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == 'K') {
				dist = dist * 1.609344;
			}
			if (unit == 'N') {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}

	useEffect(()=>{
        let sortedEmpresas = [...Empresas]; // Create a copy of the Empresas array
		switch (sortBy) {
			case 'puntuacion':
				sortedEmpresas.sort((a, b) => b.puntuacion - a.puntuacion);
				break;
			case 'distancia':
				sortedEmpresas.sort((a, b) => a.distancia - b.distancia); // Corrected to sort by ascending distance
				break;
			default:
				break;
		}
		setEmpresas(sortedEmpresas);
    },[sortBy])

    useEffect(() => {
        definirCategorias();
		//definirProvincias();
		setProvincia({
			nombre: 'Todas',
			id: 0,
		});
	}, []);

	useEffect(()=>{
		const localidadStorage = localStorage.getItem('localidades')
		if(localidadStorage){
			const localidades = JSON.parse(localidadStorage);
			let listaAux = [{'id':0,'nombre':'Todas'}]
			localidades.forEach((localidad)=>{
				listaAux.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
				});
			})

			setListaLocalidades(listaAux);
		}
	},[])

	// useEffect(() => {
	// 	if (Provincia.id !== undefined) {
	// 		axios({
	// 			method: 'get',
	// 			// url: window.ipdirection + 'localidadAll/?id_prov=' + Provincia.id,
	// 			url: window.ipdirection + 'localidadAll'
	// 		}).then((response) => {
	// 			let listaAxu = [];
	// 			/* Mapping the response data and pushing it into an array. */
	// 			listaAxu.push({
	// 				nombre: 'Todas',
	// 				id: 0,
	// 			});
	// 			response.data.forEach((localidad) => {
	// 				listaAxu.push({
	// 					id: localidad.id,
	// 					nombre: localidad.nombre,
	// 					provincia: localidad.provincia,
	// 				});
	// 			});

	// 			setListaLocalidades(listaAxu);
	// 			setLocalidad({
	// 				nombre: 'Todas',
	// 				id: 0,
	// 			});
	// 		});
	// 	}
	// }, [Provincia]);

    // const definirProvincias = () => {
	// 	axios({
	// 		method: 'get',
	// 		url: window.ipdirection + 'provinciaAll/',
	// 	}).then((response) => {
	// 		let listaAxu = [];
	// 		listaAxu.push({
	// 			nombre: 'Todas',
	// 			id: 0,
	// 		});
	// 		/* Mapping the response data and pushing it into an array. */
	// 		response.data.forEach((provincia) => {
	// 			listaAxu.push({
	// 				...provincia,
	// 			});
	// 		});
	// 		setListaProvincias(listaAxu);
	// 	});
	// };

    const definirCategorias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				let listaAxu = [];
				listaAxu.push({nombre: 'Todas', id: 0});
				response.data.map((categoria) => {
					listaAxu.push({...categoria});
				});
				setCategorias(listaAxu);
			})
			.catch((error) => {
				console.log(error);
			});
	};

    const selecionarCategoria = (event) => {
		setInputValue(event)
        setBusqueda(event)
		Categorias.map((categoria) => {
			if (categoria.nombre.toLowerCase() === event.toLowerCase()) {
				setCategoriaSeleccionada(categoria);
				setShowCategorias(false);
			}
		});
	};

    const selecionarLocalidad = (event) => {
		if (event.length > 4) {
			setShowLocalidades(true);
		}else {
			setShowLocalidades(false);
		}
		ListaLocalidades.forEach((localidad) => {
			if (localidad.nombre.toLowerCase() === event.toLowerCase()) {
				setLocalidad({...localidad});
			}
		});
	};

	useEffect(() => {
		cargarDatos();
	}, [NombreBuscar, CategoriaSeleccionada, Localidad, Provincia]);

	const cargarDatos = () => {
		setBuscarNombre(CategoriaSeleccionada.nombre);
		setBuscarCategoria(CategoriaSeleccionada.id);
		setBuscarLocalidad(Localidad.id);
		setBuscarProvincia(Provincia.id);
		return {
			nombreEmpresa: NombreBuscar,
			categoria_id: CategoriaSeleccionada,
			localidad_id: Localidad,
			provincia_id: Provincia,
		};
	};
	const searchEmpresas = async (q,lugar,distance=25, categoria) => {
		let data = cargarDatos();
		if (Usuario.tipo === 'usuarioNormal') {
			axios({
				/* Sending a post request to the server. */
				method: 'post',
				url: window.ipdirection + 'logs?logstream=buscarEmpresa',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: {
					usuario: Usuario.cliente.usuario.id,
					query: q,
					categoria: categoria,
					localidad: lugar,
					provincia: data.provincia_id.id,
					accion: 'buscarEmpresa',
				},
			})
				.then((response) => {})
				.catch((error) => {});
		}
		try {
			// Recupera la lista de empresas.
			const response = await axios({
				method: 'get',
				url:
					window.ipdirection +
					'busquedaAvanzada/?nombreEmpresa=' +
					q +
					'&categoria_id=' +
					categoria +
					'&categoria_nombre=' +
					q +
					'&localidad_id=' +
					lugar +
					'&provincia_id=' +
					data.provincia_id.id +
					'&d='+
					distance,
			});
			const empresas = response.data;

			if(!empresas) return setEmpresas([])

			const coord = await getDistance(lugar)

			try {
				// Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
				const empresasConImagenes = await Promise.all(
					empresas.map(async (empresa) => {
						try {


							const imagenResponse = await axios.get(
								window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`,
								{ responseType: 'blob' }
							);
							
							const imagenURL = URL.createObjectURL(imagenResponse.data);

							const valoraciones = await axios.get(window.ipdirection + "mediaPrestador/?prestadorServicios=" + empresa.id)
															.then((response)=>{
																return response.data.media
															}).catch(()=>{
																return 5
															})
							
							if (lugar != 0){
								const response_sedes = await axios.get(window.ipdirection + 'sedePrestador/?idempresa='+ empresa.id)
								const empresa_sede =response_sedes.data
							
								const distances = empresa_sede.map((sede)=> calcular_distancia(sede.lat, sede.lng, coord.lat, coord.lng, 'K'))
								const distanciaMin = parseFloat(Math.min(...distances).toFixed(2))

								return { ...empresa, img: imagenURL, puntuacion: valoraciones, distancia:distanciaMin };
							}


							// Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
							return { ...empresa, img: imagenURL, puntuacion: valoraciones};
						} catch (error) {
							console.error(`Error obteniendo imagen para la empresa ${empresa.id}:`, error);
							return {
								...empresa,
								img: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
							};
						}
					})
				);
		
				// Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
				setEmpresas(empresasConImagenes);
				setLoading(false)
			} catch (error) {
				console.error('Error en imagenesEmpresa:', error);
			}
			// setEmpresas(empresas)
		} catch (error) {
			console.log(error);
		}

	}

	const searchEmpresas_Cargadas = async (q,lugar,distance=25, categoria) => {
		let data = cargarDatos();
		try {
			// Recupera la lista de empresas.
			const response = await axios({
				method: 'get',
				url:
					window.ipdirection +
					'BusquedaAvanzada_PreRegistrados/?nombreEmpresa=' +
					q+
					'&categoria_id=' +
					categoria +
					'&categoria_nombre=' +
					q+
					'&localidad_id=' +
					lugar +
					'&provincia_id=' +
					data.provincia_id.id +
					'&d='+ distance +
					"&limite="+limite+
					"&prevLimite=0",
			});
			const empresas = response.data;
			try {
				// Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
				const empresasConImagenes = await Promise.all(
					empresas.map(async (empresa) => {						
						try {
							const imagenResponse = await axios.get(
								window.ipdirection + `imagenPerfilEmpresaPreregistrada/${empresa.id}/`,
								{ responseType: 'blob' }
							);
							const imagenURL = URL.createObjectURL(imagenResponse.data);
							// Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
							return { ...empresa, img: imagenURL };
						} catch (error) {
							console.error(`Error obteniendo imagen para la empresa ${empresa.id}:`, error);
							return {
								...empresa,
								img: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
							};
						}
					})
				);
				// Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
				setEmpresasCargadas(empresasConImagenes);
				setLoadingCargadas(false)
			} catch (error) {
				console.error('Error en imagenesEmpresa:', error);
			}
		} catch (error) {
			console.log(error);
		}
	
	}	

	const [showCategorias, setShowCategorias] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [mostrarMasCategorias, setMostrarMasCategorias] = useState(false);

	const matchCategoria = (input, nombreCategoria) => {
		const normalize = (str) =>
			str
				.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, ""); // Elimina acentos

		const inputWords = normalize(input).split(" ");
		const categoriaWords = normalize(nombreCategoria).split(" ");

		return inputWords.every((word) =>
			categoriaWords.some((cateWord) => cateWord.includes(word))
		);
	};

	const categoriasDivididas = () => {
		// Filtramos las categorías principales que existen en Categorias
		const principales = Categorias.filter(cat => 
		  categoriasPrincipales.includes(cat.nombre)
		);
		
		// El resto de categorías (excluyendo las principales)
		const resto = Categorias.filter(cat => 
		  !categoriasPrincipales.includes(cat.nombre)
		);
		
		return { principales, resto };
	  };


    return (
		<>
		<div className='buscadorPorNombre_superior'>
			<div className='buscadorPorNombre'>
				<div className="position-relative">
					<input type='text' className="input-buscador border-0 form-control" placeholder="¿Qué quieres?"
							value={inputValue}
							onChange={(e)=>{selecionarCategoria(e.target.value);}}
							onFocus={() => setShowCategorias(!showCategorias)}
							
						/>
						{
							showCategorias &&
							<ul className="dropdown-list">
								{/* {Categorias.slice(0, mostrarMasCategorias ? Categorias.length : 9).filter((categoria) =>
									matchCategoria(inputValue, categoria.nombre)
								).map((categoria) => (
									<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
									>
										{categoria.nombre}
									</li>
								))}
								<li className='text-center text-primary'
									onClick={() => setMostrarMasCategorias(!mostrarMasCategorias)}
								>
									{ !mostrarMasCategorias ? 'Mostrar más' : 'Mostrar menos'}
								</li> */}

								{
									categoriasDivididas().principales
									.filter(categoria => matchCategoria(inputValue, categoria.nombre))
									.map(categoria => (
										<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
										>
										{categoria.nombre}
										</li>
									))
								}
								
								{(mostrarMasCategorias || inputValue) && 
									categoriasDivididas().resto
									.filter(categoria => matchCategoria(inputValue, categoria.nombre))
									.map(categoria => (
										<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
										>
										{categoria.nombre}
										</li>
									))
								}
								
								{!inputValue && categoriasDivididas().resto.length > 0 && (
								<li 
									className='text-center text-primary'
									onClick={() => setMostrarMasCategorias(!mostrarMasCategorias)}
								>
									{mostrarMasCategorias ? 'Mostrar menos' : 'Mostrar más'}
								</li>
								)}
							</ul>
						}
					</div>
				<div className='item-buscadorPorNombre'>
                    {/* <input className="form-control" list="datalistLocalidad" id="exampleDataList" placeholder="Localidad" onChange={(e)=>{selecionarLocalidad(e.target.value);}}/>
                    {
						showLocalidades && (
							<datalist id="datalistLocalidad">
								{ListaLocalidades.map((localidad) => (
									<option key={localidad.id} value={localidad.nombre + ', ' + localidad?.provincia?.nombre} />
								))}
							</datalist>
						)
					} */}
					<BuscadorLocalidad ListaLocalidades={ListaLocalidades} setLocalidad={setLocalidad}/>
                </div>

				<div className='item-buscadorPorNombre centrador_item-buscadorPorNombre'>
					<div
						className=' buttonBuscar-buscador'
                        onClick={()=>{navigate({
							search: '?' + createSearchParams({q: busqueda, lugar:Localidad.id, categoria:CategoriaSeleccionada.id})
						})}
					}>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='18'
								height='18'
								fill='currentColor'
								class='bi bi-search'
								viewBox='0 0 16 16'
							>
								<path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
							</svg>
						</div>
					</div>
				</div>
				<div className='item-buscadorPorNombre centrador_item-buscadorPorNombre'>
					<br />
				</div>
			</div>
		</div>
		<div className='flex flex-nowrap justify-between m-auto p-1 cursor-pointer' data-toggle="tooltip" data-placement="top" title="Todos los servicios prestados a través de Cuidatia cumplen con los requisitos legales y están avalados por personal con cédula profesional válida.">
			<p>
				✅ Profesionales certificados | 
			</p>
			<p>
				🏛️ Homologados por la Administración Pública
			</p>
		</div>
		</>
	);
}
